<template>
  <div class="vgt-global-search vgt-clearfix" style="width: 100%">
    <div class="vgt-global-search__input vgt-pull-right">
      <span class="input__icon ts-cursor-pointer" @click.prevent="onEnter"
        ><div class="magnifying-glass"></div
      ></span>
      <input
        v-model="model.search_value"
        type="text"
        ref="search_barcode"
        @keypress.enter="onEnter"
        placeholder="Search product(Press F2 move focus)"
        class="vgt-input vgt-pull-right"
      />
      <span class="input__icon ts-cursor-pointer" @click.prevent="onEnter"
        ><div class="magnifying-glass"></div
      ></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      model: {
        search_value: ''
      }
    }
  },
  mounted () {
    this.$refs.search_barcode.focus()
  },
  created () {
    window.addEventListener('keydown', e => {
      if (e.keyCode == 113) {
        this.$refs.search_barcode.focus()
      }
    })
    this.model = this.value
  },
  methods: {
    onEnter () {
      this.$emit('onEnter')
    }
  }
}
</script>
